import Error from './component'
export default Error
